import React, { memo } from "react";
import { MainSliderMobile } from "components/Slider";
import { imagePath } from "helper";

const ClientMobile = ({ data }) => {
  return (
    <>
      <MainSliderMobile autoPlay={true} dots={false}>
        {data?.client_list.map((item, index) => (
          <div className="relative !block" key={index}>
            <img
              src={imagePath(data.id, item, data.collectionName)}
              alt={item}
              className="w-full"
              loading="lazy"
            />
          </div>
        ))}
      </MainSliderMobile>
    </>
  );
};

export default memo(ClientMobile);
